import React from 'react';
import { TopBarActions, TopBarAction } from './TopBarActions';
import './ViewHeader.css';

interface ViewHeaderProps {
  actions: TopBarAction[];
  className?: string;
  navLabel?: string;
  variant?: 'default' | 'inverse' | 'muted';
}

export const ViewHeader: React.FC<ViewHeaderProps> = ({
  actions,
  className,
  navLabel,
  variant = 'muted',
}) => {
  const classes = ['view-header', className].filter(Boolean).join(' ');

  return (
    <header className={classes}>
      <div className="view-header__inner">
        <TopBarActions actions={actions} navLabel={navLabel} variant={variant} />
      </div>
    </header>
  );
};
